import { useRef, useState } from 'react'

import { CameraCaptureModal } from './CameraCaptureModal'
import { fileToAttachment } from './fileToAttachment'

interface Options {
  // 撮った・選んだ 1 枚 (送る形にしたもの)
  onBlob: (blob: Blob) => void
  // ファイルを送る形にできなかった理由 (画像として読めない・大きすぎる)
  onUnreadable: (reason: string) => void
}

// 資料を足す口の裏方。「撮る」は画面内カメラの modal (続けて撮れる。閉じるのは ✕)、「選ぶ」はファイル選択
// (画像・PDF・複数)。一覧と panel が同じ口を使う (design-book 02-components/attachments-panel.md「足す口」)。
// 端末で変えるものは無い。撮った 1 枚は後ろで記録に送る。
export const useAttachmentPicker = ({ onBlob, onUnreadable }: Options) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [captureOpen, setCaptureOpen] = useState(false)

  const addFiles = async (files: File[]) => {
    for (const file of files) {
      try {
        onBlob(await fileToAttachment(file))
      } catch (err) {
        onUnreadable(
          err instanceof Error ? err.message : '画像読込に失敗しました'
        )
      }
    }
  }

  const elements = (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*,application/pdf"
        multiple
        hidden
        onChange={(e) => {
          const files = Array.from(e.target.files ?? [])
          e.target.value = '' // 同じファイルを続けて選べるよう毎回 reset
          void addFiles(files)
        }}
      />
      <CameraCaptureModal
        open={captureOpen}
        onClose={() => setCaptureOpen(false)}
        onCapture={onBlob}
      />
    </>
  )

  return {
    openCamera: () => setCaptureOpen(true),
    openFilePicker: () => fileInputRef.current?.click(),
    addFiles,
    // 呼び出し側の JSX に 1 度だけ置く (hidden の input と撮影の modal)
    elements,
  }
}
